// Configuración de ambiente
export const API_CONFIG = {
  // Desarrollo local (por defecto). En producción usar REACT_APP_API_URL.
  BASE_URL: process.env.REACT_APP_API_URL || "http://localhost:4000",
  SOCKET_URL: process.env.REACT_APP_SOCKET_URL || "http://localhost:4000",
};

// Colores del tema
export const THEME_COLORS = {
  primary: "#1976d2",
  primaryLight: "#42a5f5",
  primaryDark: "#115293",
  secondary: "#0288d1",
  success: "#4caf50",
  warning: "#ff9800",
  error: "#f44336",
  info: "#2196f3",
  background: "#f5f7fb",
  cardBorder: "#e9eef5",
  text: {
    primary: "#2c3e50",
    secondary: "#546e7a",
    disabled: "#90a4ae",
  },
};

// Configuración de KPIs principales
export const KPI_CONFIG = [
  {
    key: "clientsActive",
    title: "Clientes activos",
    subtitle: "Total de clientes registrados",
    icon: "PeopleIcon",
    color: "#1976d2",
    gradient: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
    category: "general",
  },
  {
    key: "branches",
    title: "Sucursales",
    subtitle: "Total de sucursales registradas",
    icon: "StoreIcon",
    color: "#0288d1",
    gradient: "linear-gradient(135deg, #f093fb 0%, #f5576c 100%)",
    category: "general",
  },
  {
    key: "technicians",
    title: "Técnicos",
    subtitle: "Técnicos disponibles",
    icon: "EngineeringIcon",
    color: "#2196f3",
    gradient: "linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)",
    category: "general",
  },
  {
    key: "inventoryItems",
    title: "Ítems en inventario",
    subtitle: "Total de piezas/ítems activos",
    icon: "InventoryIcon",
    color: "#42a5f5",
    gradient: "linear-gradient(135deg, #fa709a 0%, #fee140 100%)",
    category: "general",
  },
  {
    key: "servicesActive",
    title: "Servicios completados",
    subtitle: "Total de servicios finalizados",
    icon: "BuildCircleIcon",
    color: "#4caf50",
    gradient: "linear-gradient(135deg, #43e97b 0%, #38f9d7 100%)",
    category: "services",
  },
  {
    key: "servicesThisMonth",
    title: "Servicios este mes",
    subtitle: "Servicios creados en el mes actual",
    icon: "CalendarMonthIcon",
    color: "#9c27b0",
    gradient: "linear-gradient(135deg, #a855f7 0%, #ec4899 100%)",
    category: "services",
  },
];

// Configuración de KPIs de servicios
export const SERVICE_KPI_CONFIG = [
  {
    key: "servicesPending",
    title: "Pendientes",
    subtitle: "Servicios pendientes",
    icon: "PendingIcon",
    color: "#ff9800",
    gradient: "linear-gradient(135deg, #ffa726 0%, #fb8c00 100%)",
  },
  {
    key: "servicesScheduled",
    title: "Programados",
    subtitle: "Servicios programados",
    icon: "ScheduleIcon",
    color: "#2196f3",
    gradient: "linear-gradient(135deg, #42a5f5 0%, #1e88e5 100%)",
  },
  {
    key: "servicesInProgress",
    title: "En progreso",
    subtitle: "Servicios en ejecución",
    icon: "ProgressIcon",
    color: "#9c27b0",
    gradient: "linear-gradient(135deg, #ab47bc 0%, #8e24aa 100%)",
  },
];

// Roles y sus configuraciones
export const ROLE_CONFIG = {
  admin: {
    label: "ADMINISTRADOR(A)",
    color: "#f44336",
    bgColor: "#ffe6e6",
    fontWeight: 700,
  },
  supervisor: {
    label: "SUPERVISOR(A)",
    color: "#1976d2",
    bgColor: "#e8f0ff",
    fontWeight: 700,
  },
  scheduler: {
    label: "PROGRAMADOR(A)",
    color: "#f57c00",
    bgColor: "#fff4e0",
    fontWeight: 700,
  },
  dev: {
    label: "DESARROLLO",
    color: "#0f766e",
    bgColor: "#ccfbf1",
    fontWeight: 700,
  },
  member: {
    label: "MIEMBRO",
    color: "#475569",
    bgColor: "#f1f5f9",
    fontWeight: 700,
  },
  crm_manager: {
    label: "JEFE DE VENTAS",
    color: "#7c3aed",
    bgColor: "#f1e9ff",
    fontWeight: 700,
  },
  crm_agent: {
    label: "VENDEDOR(A)",
    color: "#0891b2",
    bgColor: "#e0f7fb",
    fontWeight: 700,
  },
  default: {
    label: "USUARIO",
    color: "#556677",
    bgColor: "#f0f2f5",
    fontWeight: 600,
  },
};

// Configuración de chat
export const CHAT_CONFIG = {
  height: 520,
  width: "45%",
  maxMessageWidth: "75%",
  scrollThreshold: 60,
  autoScrollDelay: 100,
};

// Animaciones
export const ANIMATIONS = {
  fadeIn: {
    "@keyframes fadeIn": {
      from: { opacity: 0, transform: "translateY(10px)" },
      to: { opacity: 1, transform: "translateY(0)" },
    },
  },
  slideIn: {
    "@keyframes slideIn": {
      from: { opacity: 0, transform: "translateX(-20px)" },
      to: { opacity: 1, transform: "translateX(0)" },
    },
  },
  pulse: {
    "@keyframes pulse": {
      "0%, 100%": { opacity: 1 },
      "50%": { opacity: 0.5 },
    },
  },
  shimmer: {
    "@keyframes shimmer": {
      "0%": { backgroundPosition: "-1000px 0" },
      "100%": { backgroundPosition: "1000px 0" },
    },
  },
};

// Formato de fecha y hora
export const DATE_FORMAT_OPTIONS = {
  date: {
    weekday: "long",
    year: "numeric",
    month: "long",
    day: "numeric",
  },
  time: {
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: false,
  },
  messageTime: {
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
  },
};

/**
 * Props estándar para inputs de tipo "time" en formato 24H
 * Usar en todos los TextField con type="time" para garantizar formato 24H consistente
 */
export const TIME_INPUT_24H_PROPS = {
  slotProps: {
    input: {
      step: 3600, // Intervalos de 1 hora
    },
  },
  inputProps: {
    step: 3600, // Compatibilidad con navegadores antiguos
  },
};